import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import zh from '@/locales/zh.json'
import en from '@/locales/en.json'
import { resolveInitialLocale, FALLBACK_LOCALE, SUPPORTED_LOCALES } from './config'
import { urlLocale } from '@/lib/publicLocale'

// URL 声明的语言优先（/en/* 强制 en — hreflang/OG 语义，见 src/lib/publicLocale.ts），
// 否则用户偏好（localStorage → navigator）。控制台/zh 公开页不在此改写。
export const initialLocale =
  typeof window !== 'undefined'
    ? (urlLocale(window.location.pathname) ?? resolveInitialLocale())
    : resolveInitialLocale()
if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLocale
}

i18n
  .use(initReactI18next)
  .init({
    resources: { zh: { translation: zh }, en: { translation: en } },
    lng: initialLocale,
    fallbackLng: FALLBACK_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    interpolation: { escapeValue: false },
    returnNull: false,
    initImmediate: false,
    react: { useSuspense: false },
  })
  .catch((err) => {
    console.error('[i18n] init failed', err)
  })

export default i18n
